import React, {memo, useEffect, useMemo, useState} from "react";
import {Link, useHistory, useLocation} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import {useCollectionData} from "react-firebase-hooks/firestore";
import {tickersRef, tickerStateRef} from "../../config/firebaseConfig";
import {getCurrentTickerNumber, getMillisToNextEvent} from "../../helpers/timeHelpers";
import {FrontendRoutes} from "../../constants";

const useStyles = makeStyles({
    tickerHeader: {
        position: 'absolute',
        top: '0px',
        right: '0px',
    },
    closeIcon: {
        marginRight: 1,
        padding: 4,
        fontSize: '1.5vw',
        cursor: 'pointer',
        height: '30%',
        margin: '5px 10px',
    }
});

const NewsTicker = () => {
    const [showTicker, setShowTicker] = useState(true);
    const [tickerNumber, setTickerNumber] = useState(null);

    const [tickers] = useCollectionData(tickersRef, {idField: 'number'})

    const location = useLocation()

    useEffect(() => {
        const millisToNext = getMillisToNextEvent()
        const UPDATE_INTERVAL = 60 * 1000
        let int = null
        let timeout = null

        setTickerNumber(getCurrentTickerNumber())

        if(millisToNext) {
            timeout = setTimeout(() => {
                int = setInterval(() => {
                    setTickerNumber(getCurrentTickerNumber())
                }, UPDATE_INTERVAL)
            }, millisToNext)
        }

        return () => {
            clearTimeout(timeout)
            clearInterval(int)
        }
    }, [])

    const classes = useStyles()

    const ticker = useMemo(() => (tickerNumber && tickers) ?
        tickers.find(t => t.number === '' + tickerNumber) : null
        , [tickerNumber, tickers])

    useEffect(() => {
        setShowTicker(true)
    }, [ticker])


    if (!showTicker ||
        !ticker
        || location.pathname === FrontendRoutes.PHOTO_BOOTH
        || location.pathname === FrontendRoutes.SOCIAL_WALL
    )
        return null

    else return (
        <div className={'news-ticker-container'} style={{ pointerEvents: 'all'}}>
            <div className={classes.tickerHeader}>
                <div className={classes.closeIcon} onClick={() => setShowTicker(false)}>&times;</div>
            </div>
            <div className={'news-ticker-section'}>
                <div className={'news-ticker'}>
                    <p className={'news-ticker-title'}>{ticker.title}</p>
                    <p className={'news-ticker-content'}>{ticker.content}</p>
                </div>
                <div style={{marginTop: '-0.5vw'}}>
                    <Link to={ticker.goto}>
                        <button className={'news-ticker-button'}>Go</button>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default memo(NewsTicker)